import { JsonUtils } from '../../utils/json.util'
import { ActiveSearchCity } from './active.search.by.city'

export class ActiveSearchState {
    private _state: string | undefined
    private _cities: ActiveSearchCity[] | undefined


    get state(): string | undefined {
        return this._state
    }

    set state(value: string | undefined) {
        this._state = value
    }

    get cities(): ActiveSearchCity[] | undefined {
        return this._cities
    }

    set cities(value: ActiveSearchCity[] | undefined) {
        this._cities = value
    }
    public fromJSON(json: any): ActiveSearchState {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.state !== undefined) {
            this.state = json.state
        }
        if (json.cities !== undefined) {
            this.cities = json.cities?.map((item:ActiveSearchCity)=>new ActiveSearchCity().fromJSON(item))
        }
        return this
    }
    public toJSON(): any {
        return {
            state: this.state || undefined,
            cities: this.cities || undefined
        }
    }


}